import React,{ useState } from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Avatars from "./Avatars";
import MenuBtn from './MenuBtn';
import Tooltip from '@material-ui/core/Tooltip';

// import RadioBtns from './RadioBtns';

// import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
// import Avatar from '@material-ui/core/Avatar';
const ProductViewHeader = {
   borderBottom: "1px solid #c7c7c7",
   minHeight: "42px"
}



const MenuPositions = (props) => {

   const [open,setOpen] = React.useState(false);



   const handleOpen = () => {
      if (window.localStorage.getItem('laptop') == 'laptop180') {
         setOpen(true);
         // console.log('a')
      }
      else if (window.localStorage.getItem('laptop') == 'laptop360') {
         setOpen(false);
         // console.log('b')
      }

   };
   const handleClose = () => {
      setTimeout(() => {
         setOpen(false);
      },300);
   }

   return (
      <div className="Accordians">
         {/* <Tooltip id="tooltips" open={open} onOpen={handleOpen} onClose={handleClose} title="Not available in selected product type" placement="right" arrow> */}
         <Accordion title="" disabled={props.disply} style={{ borderRadius: "0px",borderBottom: '1px solid #CCCCCC' }} onChange={props.onChanged} expanded={props.expanded}>
            <AccordionSummary id="positionBtn" tabIndex="1"
               expandIcon={<ExpandMoreIcon />} style={ProductViewHeader}>
               <Typography className="accordion-headers AccordiansHeader" style={{ fontWeight: "700" }}>{props.name}</Typography>
            </AccordionSummary>
            <AccordionDetails tabIndex="1" aria-label="Pivot Monitor" id="pivotBtn" onKeyPress={props.pivotAnim} onClick={props.pivotAnim}>
               <MenuBtn aria-hidden="true" submenu={window.finalLangues.pivotAnim} source={props.imgpivot} />
            </AccordionDetails>

            <AccordionDetails tabIndex="1" aria-label="Swivel base" id="swivelBtn" onKeyPress={props.swivelAnim} onClick={props.swivelAnim}>
               <MenuBtn aria-hidden="true" submenu={window.finalLangues.swivelAnim} source={props.imgswivel} />
            </AccordionDetails>

            <AccordionDetails tabIndex="1" aria-label="Adjust Height" id="heightBtn" onKeyPress={props.heightAnim} onClick={props.heightAnim}>
               <MenuBtn aria-hidden="true" submenu={window.finalLangues.adjustAnim}  source={props.imgheight} />

            </AccordionDetails>
            <AccordionDetails tabIndex="1" aria-label="Tilt Screen " id="tiltScreenBtn" onKeyPress={props.tiltScreenAnim} onClick={props.tiltScreenAnim}>
               <MenuBtn aria-hidden="true" submenu={window.finalLangues.tiltAnim} source={props.imgtilt} />

            </AccordionDetails>

            {/* <AccordionDetails tabIndex="1" aria-label="Slate Screen " id="slateScreenBtn" onKeyPress={props.slateScreenAnim} onClick={props.slateScreenAnim}>
               <MenuBtn aria-hidden="true" submenu={window.finalLangues.slateAnim} source={props.imgslate} />

            </AccordionDetails> */}
         </Accordion>
         {/* </Tooltip> */}
      </div>
   );
}

export default MenuPositions;